import { RootState } from "../redux/reducers";
import { store } from "../redux/store";
import httpService from "./httpService";
import  { C2BOrderCreateDto, C2BOrderDto, C2BOrderMetaOutDto, PayoutTransactionDto } from "./model/marketplace.model";

export async function createOrders(createDtos: C2BOrderCreateDto[]): Promise<void> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .post<void>(`/marketplace/${selectedBusiness}/c2b-orders`, createDtos)
        .then(() => {})
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getOrders(productId: string): Promise<C2BOrderDto[]> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<C2BOrderDto[]>(`/marketplace/${selectedBusiness}/c2b-orders/product/${productId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

    


export async function deleteOrder(orderId: number): Promise<void> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .delete(`/marketplace/${selectedBusiness}/c2b-orders/${orderId}`)
        .then(() => {})
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}


export async function getOrdersForUserMetadata(userId: number): Promise<C2BOrderMetaOutDto> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<C2BOrderMetaOutDto>(`/marketplace/${selectedBusiness}/c2b-orders/user/${userId}/meta`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getOrdersForUser(userId: number): Promise<C2BOrderDto[]> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<C2BOrderDto[]>(`/marketplace/${selectedBusiness}/c2b-orders/user/${userId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getPayoutTransactionsForBusiness(): Promise<PayoutTransactionDto[]> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<PayoutTransactionDto[]>(`/marketplace/${selectedBusiness}/payout-transactions`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getPayoutTransactionForBusiness(transactionId: string): Promise<PayoutTransactionDto[]> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<PayoutTransactionDto[]>(`/marketplace/${selectedBusiness}/payout-transactions/${transactionId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401 || err.response.status === 403) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getTicketUnitsOnEvent(eventId: number): Promise<C2BOrderDto[]> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<C2BOrderDto[]>(`/marketplace/${selectedBusiness}/event/${eventId}/ticket-units`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}